import React from "react";
import Commment from "../../components/SelectDevice/Comments";
import Navbar from "../../../components/Navbar";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Footer from "../../../components/Footer";
import MobileNav from "../../components/CareplanConfirmed/Address/MobileNav";
import ScreenNav from "../../components/CareplanConfirmed/Address/ScreenNav";
import Issues from "../../components/Issues/Issues";

function CareplanConfirmed() {
  return (
    <div>
      <div className="bg-[#F9FAFB] sm:mx-[60px] pt-[16px] px-[30px] pb-[90px] min-h-[680px] rounded-b-[40px] ">
        <div>
          <Navbar />
        </div>
        <div className="lg:hidden flex justify-center items-center my-8">
          <MobileNav />
        </div>
        <div className="grid sm:grid-cols-6 grid-cols-1 justify-center mt-[48px]">
          <div className="col-span-4 sm:ml-[48px] ">
            <div className="text-left">
              <h1 className="sm:text-4xl text-3xl font-plus-jakarta-sans text-[#101828] sm:text-center text-left lg:text-left font-bold leading-[44px] max-w-[300px] lg:max-w-[500px]">
                Care Plan Confirmation
              </h1>
              <p className="text-gray-500 font-plus-jakarta-sans mt-[8px]">
                Confirmation mail has been sent it over your mail and phone
                number. Please check
              </p>
            </div>
            <div className="flex flex-col gap-[24px] mt-[32px] mr-[20px]">
              <div className="p-[32px] border rounded-[16px]">
                <div className="text-start">
                  <h3 className="text-[28px] font-bold leading-[24px] mb-3">
                    Payment Details
                  </h3>
                  <p className="text-[#475467] text-sm">
                    Payment Status: Successful/Failed
                  </p>
                  <p className="text-[#475467] text-sm">
                    Payment Transaction Reference:
                  </p>
                  <p className="text-[#475467] text-sm">Total Amount: 100 </p>
                  <p className="text-[#475467] text-sm">Discount(GR20): 20</p>
                  <p className="text-[#475467] text-sm">Amount Collected: 80</p>
                </div>
              </div>
              <div className="p-[32px] border rounded-[16px]">
                <div className="text-start">
                  <h3 className="text-[28px] font-bold leading-[24px] mb-3">
                    Care Plan Details
                  </h3>
                  <p className="text-[#475467] text-sm">
                    Care Policy number:{" "}
                    <span className="font-bold">5674732</span>
                  </p>
                  <p className="text-[#475467] text-sm">Care Plan:</p>
                  <p className="text-[#475467] text-sm">Brand & Model:</p>
                  <p className="text-[#475467] text-sm">
                    Device Value & Purchase Period:
                  </p>
                  <p className="text-[#475467] text-sm">Deductibles:</p>
                </div>
              </div>
              <div className="p-[32px] border rounded-[16px]">
                <div className="text-start">
                  <h3 className="text-[28px] font-bold leading-[24px] mb-3">
                    Additional Information
                  </h3>
                  <p className="text-[#475467] text-sm">Name:</p>
                  <p className="text-[#475467] text-sm">Email ID:</p>
                  <p className="text-[#475467] text-sm">Mobile:</p>
                  <p className="text-[#475467] text-sm">Address:</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-2 sm:border-l sm:px-[42px]">
            <div className="lg:block hidden self-center mb-[-20px]">
              <ScreenNav />
            </div>
            <div className="pt-4 pb-8 border-b">
              <div className="flex flex-row justify-between sm:ml-12 lg:ml-0 mt-4">
                <p className="text-[#475467] font-[700] text-[14px] leading-[20px] font-grFont self-start">
                  Your Device
                </p>
                <button
                  //   onClick={handlePhoneChange}
                  className="text-[#B28F02] font-[700] text-[14px] leading-[20px] font-grFont cursor-pointer"
                >
                  Change
                </button>
              </div>
              <div className="mt-3">
                <Issues />
              </div>
            </div>
            <Commment />
          </div>
        </div>
      </div>
      <div className="sm:mx-[50px]">
        <Footer />
      </div>
    </div>
  );
}

export default CareplanConfirmed;
